import { createContext } from 'react';
const AlarmsContext = createContext({});

export default AlarmsContext;
